<template>
  <div class="legal-page">
<h2>特定商取引法に基づく表記</h2>
<dl>
<dt>販売会社</dt>
<dd>株式会社ザッパラス</dd>
<dt>事業責任者</dt>
<dd>代表取締役　川嶋　真理</dd>
<dt>所在地住所</dt>
<dd>〒151-0051<br>
東京都渋谷区千駄ヶ谷３ー５１ー７</dd>
<dt>お問い合わせ窓口</dt>
<dd>カスタマサポートセンター<br>
<b>受付時間</b>：平日10:00～19:00<br>
<b>電話番号</b>：<a href="tel:03-5656-2758">03-5656-2758</a><br>
</dd>
<dt>販売価格</dt>
<dd>販売価格はご購入されるサービスにより異なります。詳細は各サービスの販売画面をご確認ください。</dd>
<dt>販売価格以外にお客様が必要となる料金</dt>
<dd>当サービスの閲覧、コンテンツのダウンロード等に必要となる通信料は別途お客様負担となります。それぞれの料金は、お客様と通信サービス各社とのご契約内容により異なります。</dd>
<dt>お支払方法</dt>
<dd>ご利用される当サービスの提供形態やご利用されている通信端末提供会社によって以下のいずれかのお支払い方法をご利用頂けます。<br>
<ul>
<li>クレジットカード</li>
<li>ドコモ払い</li>
<li>auかんたん決済</li>
<li>ソフトバンクまとめて支払い(B)</li>
<li>PayPay</li>
<li>LINE Pay</li>
<li>Amazon Pay</li>
</ul>
</dd>
<dt>役務の提供時期</dt>
<dd><b>クレジットカードの場合</b><br>入会日より入会翌月の入会日前日までを1ヶ月と定め、入会翌月の入会日同日を以って次月の課金とします。お客様が月額会員サービスの提供を停止するまで自動的に月額料金の課金が継続されます。<br>
入会日が月末の場合、入会翌月末の前日までを1ヶ月と定めます。また、入会日が29日もしくは30日の月末ではない日で、入会翌月に入会日と同日が存在しない場合は、末日の前日までを1ヶ月と定めます。
</dd>
<dt>別メールアドレスでの登録と決済について</dt>
<dd>決済時において、異なるアカウントやメールアドレスを登録された場合、決済履歴の統合は出来かねますので、ご留意ください</dd>
<dt>お支払い期限について</dt>
<dd><b>クレジットカード・キャリア決済・Pay決済の場合</b><br>
購入完了まで30分以内に決済を完了してください。<br>
30分以内にご購入が完了しない場合、自動的に購入手続きはキャンセルされます。ご了承ください。</dd>
<dt>提供時期</dt>
<dd>有料コンテンツは決済後、即時ご利用頂けます。<br>
<!-- ただし、「オーダーメイド型占い」など一部の商品はご提供時期がお支払いから5日以上かかる場合がございます。詳細は商品ページの記載をご確認ください。 また、-->動画の閲覧可能期限はご提供時期から1年間となります。<br>
なお、会員登録を解除されると当サービス内の会員登録が必要な全てのメニューがご利用いただけなくなります。</dd>
<dt>返金、キャンセル</dt>
<dd>ご購入及びお支払の処理が完了した後のお客様のご都合によるキャンセルならびにご返品といったご要望にはお応え致しかねます。</dd>
</dl>
  </div>
</template>

<script>
export default {
  name: "LegalPage",
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.legal-page {
  color: $col_base_black;
  font-size: 13px;
  line-height: 1.7;
  padding: 1px 4px 30px;
  h2 {
    font-weight: bold;
    font-size: 21px;
    text-align: center;
    margin: 45px 0 30px;
  }
  dl {
    padding: 0;
    margin: 0 0 1em;
    > dt {
      font-weight: bold;
      font-size: 13px;
      margin: 1.6em 0 1em;
      &:first-child {
        margin-top: 0;
      }
    }
    > dd {
      margin: 0 0 1em;
    }
  }
  ul {
    padding: 0;
    margin: 1em 0;
    > li {
      list-style: disc inside;
      margin: 0 0 0.5em 1.7em;
      text-indent: -1.3em;
    }
  }
  a {
    color: inherit;
  }
  b {
    font-weight: bold;
  }
  small {
    color: $col_temp_gray6;
    font-size: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Help/Legal.vue